// Classic › form (#1119): the public registration form (/forms/:slug). Field
// labels, help and placeholders are the league's own; the submit button's
// words and the blockers come from the forms kit.

const en = {
  state: {
    loading: 'Loading…',
    notFoundTitle: 'Registration not found',
    notFoundBody: 'This form may have been moved or removed.',
    /** Unless the league wrote its own closed message. */
    closed: 'Registration is closed right now — check back soon.',
    closedQuestion: 'Have a question? Reach out to the league directly.',
    confirmedTitle: 'Thanks for registering!',
    /** Unless the league wrote its own confirmation. */
    confirmed: 'We received your submission. The league will review it shortly.',
    unsupported: 'This form type is not yet supported.',
  },
  team: {
    none: 'No teams available',
    choose: '— Choose a team —',
  },
  /** A custom select field's empty option. */
  choose: '— Choose —',
  photo: {
    hint: 'JPG, PNG or WebP — auto-converted & resized after upload.',
    uploading: 'Optimizing & uploading…',
    uploaded: (label: string) => `✓ ${label} uploaded`,
  },
  waiver: {
    heading: 'Waiver',
    /** The waiver iframe's title. */
    document: 'Waiver document',
    open: 'Open waiver in a new tab ↗',
    agree: 'I have read and agree to the waiver.',
  },
  paymentCancelled: 'Payment was cancelled — your registration wasn’t submitted. Fill the form in again to retry.',
  /** The price breakdown before submit. */
  quote: {
    registration: 'Registration',
    serviceFee: 'Service & processing fee',
    total: 'Total',
    /** One line when the league absorbs the fee. */
    registrationFee: 'Registration fee',
  },
  paymentsUnavailable:
    'This league isn’t set up to accept payments yet, so registration can’t be completed right now. Please check back or contact the league.',
  /** The submit button's title while submitting. */
  submitting: 'Submitting your registration…',
}

export default en
